import { render, staticRenderFns } from "./Course3.vue?vue&type=template&id=5abe13e9&scoped=true"
import script from "./Course3.vue?vue&type=script&lang=ts"
export * from "./Course3.vue?vue&type=script&lang=ts"
import style0 from "@/assets/css/course.css?vue&type=style&index=0&id=5abe13e9&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe13e9",
  null
  
)

export default component.exports